'use strict';

angular.module('atex.dam').controller('DamQueuesController', ['$scope', '$rootScope', 'DamQueuesService', '$modal', 'AssignService', '$q', 'DamFileService', 'ContentService',
  function($scope, $rootScope, DamQueuesService, $modal, AssignService, $q, DamFileService, ContentService) {

    // START Private to upload images
    var uploadImage = function(file, secParentId) {
      return $q.when().then(function() {
        return DamFileService.prepareImageData(file, secParentId).then(function(data) {
          return ContentService.createContent({data : data}).then(function(response) {
            return response.id;
          });
        });
      });
    };

    var uploadImages = function(files, secParentId) {
      return $q.when().then(function() {
        var uploadImagesPromises = files.map(function(file) {
          return uploadImage(file, secParentId);
        });
        return $q.all(uploadImagesPromises).then(function(results) {
          return results;
        });
      });
    };

    var isImageType = function(type) {
      if (type.match('image.*')) {
        return true;
      }
      return false;
    };

    var isLocalImage = function(event) {
      if (event && event.originalEvent.dataTransfer && event.originalEvent.dataTransfer.files && event.originalEvent.dataTransfer.files.length>0) {
        for (var i=0; i<event.originalEvent.dataTransfer.files.length; i++) {
          if (isImageType(event.originalEvent.dataTransfer.files[i].type)) {
            return true;
          }
        }
      }
      return false;
    };

    var filterImages = function(files) {
      var images = [];
      files.forEach(function(file){
        if (isImageType(file.type)) {
          images.push(file);
        }
      });
      return images;
    };
    // END Private to upload files

    $scope.DamQueuesService = DamQueuesService;

    $scope.showSpinner = false;

    $scope.reloadFolders = function() {
      $scope.showSpinner = true;
      DamQueuesService.resetValues();
      DamQueuesService.initializeTree().then(function() {
        $scope.showSpinner = false;
      }).then(null, function(error) {
        $scope.showSpinner = false;
      });
    };

    // Callback
    $scope.nodeSelected = function(node) {
      $rootScope.$broadcast("dam:resetFoldersSelection");
      DamQueuesService.selectedNode = node;
      if (node && !node.isRoot) {
        DamQueuesService.listingFolder = node;
      }
    };

    //Callback
    $scope.expandNode = function(node) {
      if (node.exploring) {
        return;
      }
      node.exploring = true;
      $scope.showSpinner = true;
      DamQueuesService.expandNode(node).then(function(){
        $scope.showSpinner = false;
        delete node.exploring;
      }).then(null, function(error) {
        $scope.showSpinner = false;
        delete node.exploring;
      });
    };

    //Callback
    $scope.droppedOnNode = function(node, event) {
      if (node.isRoot) {
        return;
      }

      $scope.showSpinner = true;

      var eventTxt = event.originalEvent.dataTransfer.getData('Text') || '';
      // If we have text, then it is probably a local drag/drop and we should ignore the file
      if (eventTxt.length === 0 && isLocalImage(event)) {
        var fileList = Array.from(event.originalEvent.dataTransfer.files);
        var images = filterImages(fileList);
        ContentService.getContent({id: node.id}).then(function(folder) {
          var secParentId = atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/p.InsertionInfo/data/securityParentId').value;
          uploadImages(images, secParentId).then(function(results) {
            DamQueuesService.addContentToFolder(results, node, false).then(function(){
              $scope.showSpinner = false;
            }).then(null, function(error) {
              $scope.showSpinner = false;
            });
          });
        });
        return;
      }

      var dragIds = $scope.getIdsFromDragUrl(eventTxt);
      var copy = event.ctrlKey || event.metaKey;
      DamQueuesService.addContentToFolder(eventTxt, dragIds, node, copy).then(function () {
        $scope.showSpinner = false;
      }).then(null, function (error) {
        $scope.showSpinner = false;
      });
    };

    //Callback
    $scope.listNode = function(node) {
      if (node.isRoot) {
        return;
      }
      DamQueuesService.executeQuery(node);
    };

    $scope.$on("dam:resetQueuesSelection", function() {
      DamQueuesService.resetSelection(true);
    });
  }]);